import { type FC } from "react";

import { type MyLensesSubmissionError } from "../../../gql-generated/types";
import { ClosableModal, ClosableModalBody, ClosableModalHeader } from "../../../shared/components";
import { type ModalProps } from "../../../shared/hooks";
import { LensSubmissionErrorsBody } from "../list/lens-submission-errors/LensSubmissionErrorsBody";
import { ModalHeaderText } from "../list/lens-submission-errors/messages.generated";

import { lensSubmissionErrorsModalStyle } from "./LensSubmissionErrorsModal.styles";

interface LensSubmissionErrorsModalProps {
    modalProps: ModalProps;
    submissionErrors: MyLensesSubmissionError[];
    errorsLoading: boolean;
}

export const LensSubmissionErrorsModal: FC<LensSubmissionErrorsModalProps> = ({
    modalProps,
    submissionErrors,
    errorsLoading,
}) => {
    return (
        <ClosableModal modalProps={modalProps} className={lensSubmissionErrorsModalStyle}>
            <ClosableModalHeader>
                <ModalHeaderText />
            </ClosableModalHeader>
            <ClosableModalBody>
                <LensSubmissionErrorsBody submissionErrors={submissionErrors} errorsLoading={errorsLoading} />
            </ClosableModalBody>
        </ClosableModal>
    );
};
